import DeleteIcon from '@mui/icons-material/Delete';
import {
  getDateTimeBooking,
  getRoom,
  getServiceName,
} from '../../../../../../utils/utils';
import {
  Box,
  Table,
  TableBody,
  TableCell,
  TableContainer,
  TableHead,
  TableRow,
} from '@mui/material';
import moment from 'moment';
import 'moment/locale/it';
import { fieldNameResumeRow, MAX_ROW_TO_SHOW } from '../constants';
import i18n from '../../../../../../translations/strings';
import { sxListReservationSummaryRow } from './reservation-summary-row.styled';

interface ReservationSummeryRowProps {
  reservations: any[];
  rooms: any;
  onDeleteEvent: (event: any) => void
}

const ReservationSummaryRow = (props: ReservationSummeryRowProps) => {

  const showScroll = props.reservations.length > MAX_ROW_TO_SHOW;

  return (
    <TableContainer
      component={Box}
      sx={{
        maxHeight: showScroll ? '250px' : 'auto',
        overflowY: showScroll ? 'scroll' : 'auto',
        padding: '10px',
      }}
    >
      <Table
        sx={sxListReservationSummaryRow.table}
        aria-label="a dense table"
      >
        <TableHead>
          <TableRow>
            {fieldNameResumeRow.map(field => {
              return (
                <TableCell
                  sx={sxListReservationSummaryRow.tableCell}
                >
                  {field.toUpperCase()}
                </TableCell>
              );
            })}
          </TableRow>
        </TableHead>

        <TableBody component={Box}>
          {props.reservations.map((item: any, index: number) => {
            const { time: timeStart } = getDateTimeBooking(item.start);
            const { time: timeEnd } = getDateTimeBooking(item.end);
            const room = getRoom(props.rooms, item.product);
            const commonServiceNames = getServiceName(item, room);

            moment.locale('it');
            const formattedDate = moment(item.start).format('DD MMMM YYYY');
            return (
              <TableRow
                key={index.toString()}
                sx={sxListReservationSummaryRow.tableRow}
              >
                <TableCell
                  sx={sxListReservationSummaryRow.tableCellRow}
                >
                  {formattedDate}
                </TableCell>
                <TableCell
                  sx={sxListReservationSummaryRow.tableCellRow}
                >{i18n.t('booking.timeStartEndResume', {
                    start: timeStart,
                    end: timeEnd,
                  })}
                </TableCell>
                <TableCell
                  sx={sxListReservationSummaryRow.tableCellRow}
                >
                  {room.name}
                </TableCell>
                <TableCell
                  sx={sxListReservationSummaryRow.tableCellRow}
                >
                  {!!item.attendees ? item.attendees : '0'} {i18n.t('booking.attendeesResume')}
                </TableCell>
                <TableCell
                  sx={sxListReservationSummaryRow.tableCellRow}
                >
                  {!!item.remote_attendees ? item.remote_attendees : '0'} {i18n.t('booking.attendeesResume')}
                </TableCell>
                <TableCell
                  sx={sxListReservationSummaryRow.tableCellRow}
                >
                  {commonServiceNames.length > 0
                    ? commonServiceNames.join(', ')
                    : '-'}
                </TableCell>
                <TableCell
                  sx={sxListReservationSummaryRow.tableCellRow}
                >
                  <div onClick={() => props.onDeleteEvent(item)}>
                    <DeleteIcon fontSize="small" />
                  </div>
                </TableCell>
              </TableRow>
            );
          })}
        </TableBody>
      </Table>
    </TableContainer>
  );
};

export default ReservationSummaryRow;
